import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { BannersDataService, BannersColumnsService } from '../../../services';
import { Banner, BannersResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-banner-details',
  templateUrl: './banner-details.component.html',
  styleUrls: ['./banner-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class BannerDetailsComponent implements OnInit, OnDestroy {

  public banner: Banner = {};
  public banners: Banner[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private bannersDataService: BannersDataService,
    private bannersColumnsService: BannersColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Banner - Details');
        this.getBanner(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.banner !== 'undefined') {
      this.banner = this.dynamicDialogConfig.data.banner;
    }
    this.columns = this.bannersColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getBanner(id: number): void {
    this.isLoading = true;
    this.bannersDataService.getBanner(id).subscribe((response: Banner|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.banner = response;
      }
    });
  }

  list() {
    this.router.navigate(['/banners']);
  }

  add() {
    this.router.navigate(['/banners/add']);
  }

  edit() {
    this.router.navigate(['/banners/edit/' + this.banner.id]);
  }

}
@Component({
  selector: 'app-banner-details',
  templateUrl: './banner-details.component.html',
  styleUrls: ['./banner-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogBannerDetailsComponent extends BannerDetailsComponent {
}

